import axios from "axios";

const api = axios.create({
    baseURL: process.env.REACT_APP_API_BASE,
    withCredentials: true,
    headers: {
        "client-id":
            process.env.REACT_APP_CLIENT_ID,
        "client-secret":
            process.env.REACT_APP_CLIENT_SECRET,
    },
    timeout: 10000,
});

export default api;